import AppSkeleton from "../../components/Skeletons/AppSkeleton";
import styles from "../../assets/css/customSignup.module.scss";
import willowLogo from "../../assets/img/willowLogo.png";
const CustomSignupHeader = ({
  source,
  screenType,
  loader,
  handleResendMessage,
  cricbuzzData,
  handleDownload
}) => {
  const {
    subscription_plan,
    errorMsg,
    resendOtpMsg,
    isSubmitSignup,
    cashback_eligible,
    mobileNumber,
    phone,
    action_type,
  } = cricbuzzData || {};

  return (
    <>
      {screenType === 1 && (
        <>
          {source ? (
            <>
              <div className={styles.headerText}>
                Sign up on Abound to access Willow
              </div>
              <div className="abound">
                Download the <span className="aboundTxt">Abound</span> app now
                to get your 
              </div>
              <div className="abound">money. Enter phone number to get started.</div>
            </>
          ) : (
            <>
              <div className="header">
                Your {subscription_plan === "MONTHLY" && "$10"}
                {subscription_plan === "YEARLY" && "$15"} cash back is waiting
                for you
              </div>
              <div className="abound">
                Simply verify your phone number to claim the cash back on{" "}
                <span className={styles.aboundTxt}>Abound</span>
              </div>
            </>
          )}
        </>
      )}
      {screenType === 3 && (
        <>
          {source? (
            <div>
              <div className={styles.willowContainer}>
                <img src={willowLogo} alt="willow" className={styles.logo}/>
                <div className={styles.header1}>Willow offer is unlocked</div>
              </div>

              <div className={styles.willowDescr}>
                Download Abound app to activate it.
              </div>
              <div className={styles.download}>
              <button className={styles.downloadBtn} onClick={()=>handleDownload()}>Download the App</button>
              </div>
           
            </div>
          ) : (
            <div>
              <div className={styles.headerBox}>
                <div className="header">
                  {cashback_eligible === "false"
                    ? "Sorry, You're Not Eligible for Cash Back"
                    : "  Your cash back is credited"}
                </div>

                <div style={{ marginBottom: "24px" }}>
                  <div className="descrText">
                    {cashback_eligible === "false" ? (
                      `We regret to inform that you are not eligible for the cash back as your account is already registered on Abound app and redeemed this offer. You can login into the app to explore the latest deals available for you.`
                    ) : (
                      <>
                        <span>
                          We have sent an SMS with an app download link to{" "}
                        </span>
                        <span className="phoneText">
                          {action_type === "SEND_APP_LINK"
                            ? `+${mobileNumber?.replace(" ", "")}`
                            : `+1 ${phone}`}
                        </span>
                        <span>
                          . Login to your account to redeem the cash back.
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>

              {loader ? (
                <AppSkeleton height={84} width="100%" className="btnLoader" />
              ) : (
                <div>
                  <button
                    disabled={isSubmitSignup}
                    onClick={handleResendMessage}
                    className={
                      isSubmitSignup
                        ? `btnResend disabled`
                        : `btnResend blockBtn`
                    }
                  >
                    Resend sms
                  </button>
                </div>
              )}
              {resendOtpMsg && !errorMsg && (
                <div>
                  <span className="errorMsg">{resendOtpMsg}</span>
                </div>
              )}
              {errorMsg && (
                <div>
                  <span className="errorMsg">{errorMsg}</span>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default CustomSignupHeader;
